import { hot } from 'react-hot-loader/root';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { initPerformance } from '../utils/firebase';
import { Route, Switch, Router } from 'react-router';
import { ConnectedRouter } from 'connected-react-router';
import 'core-js/modules/esnext.string.replace-all';
import './App.scss';

const Loading = () => {
  return null;
};

import { CreditsPage, GalleryPage, NotFoundPage, PaymentPage, StoreNetworkPage, StoreUsersPage } from '../routes';
import { Provider } from 'react-redux';
import { browserHistory } from '../store/configureStore';

// eslint-disable-next-line react/no-multi-comp
const Root = (props) => {
  const { store } = props;
  useEffect(() => {
    initPerformance();
  }, []);

  return (
    <Provider store={store}>
      <ConnectedRouter history={browserHistory}>
        <React.Suspense fallback={<Loading />}>
          <Router history={browserHistory}>
            <Switch>
              <Route exact path="/gallery" component={GalleryPage} />
              <Route exact path="/credits" component={CreditsPage} />
              <Route exact path="/credits/:pageType" component={CreditsPage} />
              <Route exact path="/credits/:pageType/:page" component={CreditsPage} />
              <Route exact path="/credits/:pageType/:historyType" component={CreditsPage} />
              <Route exact path="/credits/:pageType/:historyType/:page" component={CreditsPage} />
              <Route exact path="/payment/:pageType/:id" component={PaymentPage} />
              <Route exact path="/users" component={StoreUsersPage} />
              <Route exact path="/users/:pagenum" component={StoreUsersPage} />
              <Route exact path="/network" component={StoreNetworkPage} />
              <Route exact path="/network/:pageType" component={StoreNetworkPage} />
              <Route exact path="/network/:pageType/:id" component={StoreNetworkPage} />
              <Route exact path="/network/:pageType/:id/:page" component={StoreNetworkPage} />
              <Route path="*" component={NotFoundPage} />
            </Switch>
          </Router>
        </React.Suspense>
      </ConnectedRouter>
    </Provider>
  );
};

Root.propTypes = {
  store: PropTypes.object.isRequired,
};

export default hot(Root);
